import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, AfterViewInit, ViewChildren, QueryList, OnDestroy, NgZone } from '@angular/core';
import { FirebaseService } from 'src/app/service/firebase.service';
import * as XLSX from 'xlsx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../modals/confirm-modal/confirm-modal.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from 'src/app/services/shared.service';
import { Subscription } from 'rxjs';
import { TranslationPipe } from '../../shared/pipes/translation.pipe';
import { WaitingComponent } from '../../modals/waiting/waiting.component';
import { ImageDisplayComponent } from '../../modals/image-display/image-display.component';

@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss']
})
export class DataComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() group: string;
  @Input() device: string;

  dataValue: Array<any> = [];
  displayedColumns: Array<any> = [];

  displayValue: any = [];
  displayDataSources: any = [];
  finalDataSources: any = [];
  dialogRef: any;

  moduleList: any = [];
  listQuiz: any = [];
  loading: boolean = true;
  noData = false;


  /*BPI Variable*/
  cvNumber: number = 0;
  cvPrint: number = 0;
  cvEmail: number = 0;
  parseDate: any;

  displayTableContainer: boolean = false;
  imgArray: any = [];

 /* @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();*/


  private dataSubscription: Subscription;
  constructor(
    public firebaseService: FirebaseService,
    private _ref: ChangeDetectorRef,
    public dialog: MatDialog,
    private sharedService: SharedService,
    public translation: TranslationPipe,
    private _ngZone: NgZone
  ) {
    if (this.sharedService.selectedDevice != null) {
      this.group = this.sharedService.selectedDevice.data.group;
      this.device = this.sharedService.selectedDevice.data.name;
    }
  }

  ngOnDestroy() {
    if (this.dataSubscription != undefined)
      this.dataSubscription.unsubscribe();
  }

  ngOnInit() {


    this.dataValue = [];
    this.firebaseService.getModuleData(this.device, this.group);

    /* this.firebaseService.getAllQuizFromDevice(this.group, this.device).then(d => {
       console.log("ALL QUIZ:",  d)
     })
     */

    //console.log("---------------------------------DATA--------------------------------------------")



  }


  ngAfterViewInit() {







    this.dataSubscription = this.firebaseService.dataModuleValues.subscribe(data => {

       console.log("GETTING DATA", data);
      //  console.log("AFTER VIEW INIT")
      /*data.data.forEach((item) => {
        console.log(item)
      })*/

      //    console.log("LIST DATA:", data)
      // console.log("SUBSCRIBE DATA:", data)

        console.log(data, this.noData);
      if (data.id.length == 0 && data.data.length == 0 || this.noData) {
        this.displayValue = [];
        this.displayValue = [];
        this.dataValue = [];

        this.loading = false;
        this._ref.detectChanges();
        return;
      }

      this.displayValue = [];
      this.dataValue = [];
      let moduleTab = [];
      if (data != null && data.data != null) {
        data.data.forEach(item => {

          if (moduleTab[item.module] == undefined)
            moduleTab[item.module] = [];




          if (item.module == 'quiz')
            item.data.idQuiz = item.quiz

          //   if(item.module != 'quiz')



          moduleTab[item.module].push(item.data)


          // if()
          /*
          if (this.dataValue.length > 0) {
            this.dataValue.forEach(elem => {

              if (elem.module == item.module) {
                if (!this.checkIfExistInListQuiz(item.quiz))
                  this.listQuiz.push({ id: item.quiz, name: '' })


                let tmp = item.data;



                let found = false;
                tmp.forEach((check) => {
                  if (check.name == 'idQuiz')
                    found = true;
                })

                if (!found) {
                  tmp.push({ name: 'idQuiz', value: item.quiz });
                }

                elem.data.push(tmp);
                this.moduleList.push(item.module)
              }

              else {
                if (!this.checkIfExistInListQuiz(item.quiz))
                  this.listQuiz.push({ id: item.quiz, name: '' })
             //  this.dataValue.push({ module: item.module, data: [item.data] })
                this.moduleList.push(item.module)
              }
            })
          }
          else {
            if (!this.checkIfExistInListQuiz(item.quiz))
              this.listQuiz.push({ id: item.quiz, name: '' })
           // this.dataValue.push({ module: item.module, data: [item.data] })
            this.moduleList.push(item.module)
          }
        this.dataValue.push({ module: item.module, data: [item.data] })*/
        })


        if (moduleTab['lottery']) {
          //  console.log(moduleTab)

       //   console.log("MODULE TAB", moduleTab['lottery'], moduleTab, data.data)

          const unique = [...new Set(data.data.filter(e => e.module == 'lottery').map(item => item.lotteryName))];

      //    console.log("UNIQUE LOTTERY", unique)

          unique.forEach((lotteryName) => {
            let dataLottery = data.data.filter(e => e.module == 'lottery' && e.lotteryName == lotteryName).map(e => e.data)

        //    console.log(dataLottery)
            this.dataValue.push({ module: 'lottery', data: dataLottery, title: lotteryName })
          })


        /*  let i = 1;
          unique.forEach((item, index) => {
            let array = mediaLottery.filter(e => e['Nom loterie'] == item)

            console.log(array, index)
            if (array) {
              this.displayValue.push(array)
              this.displayDataSources.push(new MatTableDataSource(array))*/

              //  this.dataValue.splice(i, 0, { module: 'lottery', data: Array(array.length), title: `Loterie ${item}` });


              /*  let indexs = this.dataValue.map((e, index) => e.module == 'lottery' ? index : null);
                 console.log(indexs);
                 this.dataValue.push({ module: 'lottery', data: Array(29), title: `Loterie ${item}` })*/

         //   }

       //   this.dataValue.push({ module: 'lottery', data: moduleTab['lottery'], title: this.translation.transform('lottery') })
        }




        let quizTmp = [];
        let listquizId = [];
        if (moduleTab['quiz'] != undefined) {
          moduleTab['quiz'].forEach((item) => {


            if (!listquizId.includes(item.idQuiz))
              listquizId.push(item.idQuiz)
            if (quizTmp[item.idQuiz] == undefined)
              quizTmp[item.idQuiz] = [];

            quizTmp[item.idQuiz].push(item);


          })
          listquizId.forEach((item) => {




            // this.firebaseService.getQuizData(item).then(d => {

            //    console.log("QUIZ NAME:", d.data().name)

            this.dataValue.push({ module: 'quiz', quizId: item, data: quizTmp[item], title: '' })
            //  })


          })
        }

        /* quizTmp.forEach(item => {
           console.log("ITEM FROM QUIZ:", item)
         })*/

        //moduleTab.quiz.forEach()

      }
      this.listQuiz.forEach((item, index) => {
        if (item.id != undefined)
          this.firebaseService.getQuizData(item.id).then((d:any) => {
            if (d.data() != undefined)
              item.name = d.data().name;
          })
      })


    //  console.log("BUILT DATA VALUE:", this.dataValue)






      this.dataValue.forEach((item,dataIndex) => {
        let tab = [];
        /* SET OBJECT ARRAY TO OBJECT */
        //   if (item.module != 'quiz') {
        if (item.data != undefined)
          item.data.forEach(value => {
            let elem = {};
            value.forEach(element => {

              elem[element.name] = element.value
            })

            //  console.log(elem)
            tab.push(elem);
          })

        if (item.module != 'quiz')
          tab = tab.sort(function (a, b) {
            let convertDateA = strToDate(a.Date);
            let convertDateB = strToDate(b.Date);

            if (a.Date == undefined || b.Date == undefined)
              return 0;

            if (new Date(convertDateA) < new Date(convertDateB)) {
              return 1;
            }

            if (new Date(convertDateA) > new Date(convertDateB)) {
              return -1;
            }

            return 0

          })




        if (item.module == 'quiz') {


          //   console.log(item)
          this.firebaseService.getQuizData(item.quizId).then((d:any) => {
            if (d.data()) {
              item.title = d.data().name;
              this.displayValue.push(tab)


              if (this.displayDataSources != null)
                this.displayDataSources.push(tab)
            /*   this.displayDataSources.forEach((sources, index) => {
    
                 sources.sort = this.sort.toArray()[index];
                 sources.paginator = this.paginator.toArray()[index];


               })*/
              // console.log(this.displayDataSources)
              this.setDisplayColumns();
            }

          })


        }

        else {

          if (tab.length > 0) {


            /* PARSE DATA IN MULTIPLE TABS BY FILTER NAME */


            this.displayValue.push(tab)
            this.displayDataSources.push(tab)
            this.setDisplayColumns();
          }

        }

        //this.displayValue.push(tab)
        // tab = [];



     //   console.log(this.dataValue)
     //   console.log(this.displayDataSources)
        //   }

      })




      let i = 0;
      this.displayDataSources.forEach(item => {
        let elem = item 

      /*  console.log(elem, elem.find(e => e.Gain) && elem.find(e => e['Nom loterie']))*/
        if (elem && elem.find(e => e.Gain) && elem.find(e => e['Nom loterie'])) {

          
          let lotteryName = elem.find(e => e['Nom loterie'])['Nom loterie']
          if (lotteryName.length > 0)
            this.dataValue.splice(i, 0, { module: 'lottery', data: Array(item.lengthh), title: `Loterie ${lotteryName}` })
          else
            this.dataValue.splice(i, 0, { module: 'lottery', data: Array(item.lengthh), title: null })

        }
      })






    //  console.log("DISPLAY DATASOURCES", this.displayDataSources)

      //  console.log("DATA VALUE:", this.dataValue)
      /* FIND SOMETHINIG TO REPLACE SETTIMEOUT */
      setTimeout(() => {
        if (this.displayDataSources != null && this.displayDataSources != undefined) {
          /*Custom function for BPI*/
      //    console.log("DISPLAY DATASOURCES", this.displayDataSources)

        /*  this.displayDataSources.forEach((sources, index) => {
            sources.sort = this.sort.toArray()[index];

           // let pag =

            
                sources.paginator = this.paginator.toArray()[index];

            this.loading = false;
            this._ref.detectChanges();
          })*/

          this.loading = false;
          this._ref.detectChanges();
        }

    //    let finalDataSources = this.displayDataSources;
        

      }, 300)



    })
  }





  /* onQuizSelection(dataTable, dataValue, index, id) {
 
 
   // console.log("QUIZ SELECTION")
 
 
     this.displayDataSources = [];
     let localDataValue = JSON.parse(JSON.stringify(this.dataValue))
 
    // console.log("LOCALVALUE BEFORE:", localDataValue)
     let tmp = [];
     localDataValue.forEach((test, indexTab) => {
       if (index == indexTab) {
         test.data.forEach(val => {
 
 
           val.forEach(lastValue => {
             if (lastValue.name == 'idQuiz' && lastValue.value == id)
               tmp.push(val);
           })
 
         })
         test.data = tmp;
 
 
       }
 
     })
 
 
     let v = localDataValue[index].data
     let newDisplayColumns = [];
     v[0].forEach(item => {
       if(item.name != 'idQuiz')
       newDisplayColumns.push(item.name)
     })
    // console.log(newDisplayColumns, this.displayedColumns[index]);
 
     this.displayedColumns[index] = newDisplayColumns;
 
     let value;
     let tab = [];
 
 
 
    // console.log("LOCALVALUE:", localDataValue)
 
     localDataValue[index].data.forEach(val => {
       value = {};
       val.forEach(arrayItem => {
         value[arrayItem.name] = arrayItem.value;
       })
 
       tab.push(value)
 
 
     })
 
     localDataValue[index].data = tab;
     //console.log("VALUE:", value, tab)
 
     //console.log("Before:",  this.displayDataSources)
    // this.displayDataSources[index] = new MatTableDataSource(localDataValue[index].data)
     this.displayDataSources.forEach((sources, index) => {
 
       sources.sort = this.sort.toArray()[index];
       sources.paginator = this.paginator.toArray()[index];
     })
   //  localDataValue
     //console.log(this.displayDataSources)
   }
   */



  setDisplayColumns() {

  //  this.displayTableContainer = false;
    /* GET ALL KEY NAME FOR MAT-CELL-HEADER */
    this.displayedColumns = [];
    this.displayValue.forEach(item => {

      let keys = [];
      //  console.log(item)
      item.forEach(itemKey => {

        //  console.log(itemKey)

        for (let property in itemKey) {
          if (!keys.includes(property)) {
            //   console.log(property)


            //    console.log(keys, property)

            // console.log(property)
            if (property != 'idQuiz' && property != undefined && property != 'undefined' && property.length > 0)
              keys.push(property)
          }

        }

      })


      let sortHeader = keys.sort((a:string, b:string) => {
        if (a == 'Date')
          return -1
        else if (a == 'Date' && b == 'Gain')
          return -1
        else if (a == "Gain" && b != 'Date')
          return -1;
        else
          return 1;
      })


      console.log(sortHeader)
      this.displayedColumns.push(sortHeader)
      console.log(this.displayedColumns)

    })
 //   this.displayTableContainer = true;
    //   console.log(this.displayedColumns)
  }

  export(data, module) {

    data.forEach(item => {
      for (var property in item) {
        if (Array.isArray(item[property]))
          item[property] = item[property].join();
      }

    })

    let ws = XLSX.utils.json_to_sheet(data);
    let wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
    XLSX.writeFile(wb, `data-${module}-${new Date().getTime()}.xlsx`)
  }

  deleteData(module, quizId = null, lotteryName = null) {

  //  console.log(quizId)
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: 'Êtes-vous sûr de vouloir supprimer ces données ? (Cette action est irréversible)' }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.loading = true;
        this.displayValue = [];
        this.displayDataSources = null;
        this.noData = true;



        this.dialogRef = this.dialog.open(WaitingComponent, {
          disableClose: true,
          data: { title: 'Suppression en cours, veuillez patientez' }
        })
        if (module == 'lottery') {
          console.log("DELTE LOTTERY")
            this.firebaseService.deleteLotteryData(this.device, this.group, module, lotteryName).then(d => {
              this.loading = false;
  
              this._ref.detectChanges();
              this.dialogRef.close();
            }).catch(err => {
              console.log(err)
            })
        }
        else if (quizId == null && module != 'quiz') {
         console.log("DELETE DATA")
         this.firebaseService.deleteData(this.device, this.group, module).then(d => {
           this.loading = false;

           this._ref.detectChanges();
           this.dialogRef.close();
         }).catch(err => {
           console.log(err)
         })
      }
        else if (quizId) {
          console.log("DELETE QUIZ", this.device, this.group, module, quizId)
          this.firebaseService.deleteQuizData(this.device, this.group, module, quizId).then(d => {
            this.loading = false;

            this._ref.detectChanges();
            this.dialogRef.close();
          })
        }
      }
    });

  }


  checkIfExistInListQuiz(id) {
    let value = false;

    this.listQuiz.forEach(item => {
      if (item.id == id)
        value = true;
    })

    return value;
  }

  JSONTOSTR(json) {
    return JSON.stringify(json)
  }

  /*setDataSource(data, index) {
  //  data.paginator = this.paginator;
   // data.sort = this.sort;


    let defData = new MatTableDataSource(data)

   // console.log(this.paginator.toArray())

    /*if (this.sort.toArray()[0] != undefined) {
      defData.sort = this.sort.toArray()[0];
    

    if (defData.sort == undefined) {
      defData.sort = this.sort.toArray()[index];
    }
    return defData;
  }
  */




  changeSourceDate(op:string = null) {
    let filterDate = `${this.parseDate.getDate()}/${("0" + (this.parseDate.getMonth() + 1)).slice(-2)}/${this.parseDate.getFullYear()}`
    this.displayDataSources.forEach((data) => {
   //   const filterValue = (event.target as HTMLInputElement).value;



      if (op == 'clear') {
        this.parseDate = '';
        data.filter = ''.trim().toLowerCase();
      }
      else
      data.filter = filterDate.trim().toLowerCase();

   //   this._ref.detectChanges();


    })


  }

  openImage(element, columns) {


    this._ngZone.run(() => {
      this.dialog.open(ImageDisplayComponent, {
        width: '50vw',
        height: '50vh',
        data: {
          mediaSource: element[columns]
        }
      })
    })

  }

  checkIfUrl(element, column): boolean {
  //  console.log(element, column)

    if (validURL(element[column]))
      this.imgArray.push({ src: element[column], thumb: element[column], caption: 'signature'})
    return validURL(element[column])

  }

}

function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
}

function strToDate(dtStr) {
  let dateObject
  let dateParts = dtStr.split("/");
  let timeParts = dateParts[2].split(" ")[1].split(":");
  dateParts[2] = dateParts[2].split(" ")[0];
  // month is 0-based, that's why we need dataParts[1] - 1
  return dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1], timeParts[2]);

}
